import { toRefs, ref, reactive, defineComponent, provide, onMounted, renderSlot, inject, onUnmounted } from "vue";
var t = function(e2, r2) {
  return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t2, e3) {
    t2.__proto__ = e3;
  } || function(t2, e3) {
    for (var r3 in e3)
      Object.prototype.hasOwnProperty.call(e3, r3) && (t2[r3] = e3[r3]);
  }, t(e2, r2);
};
var e = function() {
  return e = Object.assign || function(t2) {
    for (var e2, r2 = 1, n2 = arguments.length; r2 < n2; r2++)
      for (var o2 in e2 = arguments[r2])
        Object.prototype.hasOwnProperty.call(e2, o2) && (t2[o2] = e2[o2]);
    return t2;
  }, e.apply(this, arguments);
};
function r(t2, e2, r2, n2) {
  return new (r2 || (r2 = Promise))(function(o2, i2) {
    function s2(t3) {
      try {
        c2(n2.next(t3));
      } catch (t4) {
        i2(t4);
      }
    }
    function a2(t3) {
      try {
        c2(n2.throw(t3));
      } catch (t4) {
        i2(t4);
      }
    }
    function c2(t3) {
      var e3;
      t3.done ? o2(t3.value) : (e3 = t3.value, e3 instanceof r2 ? e3 : new r2(function(t4) {
        t4(e3);
      })).then(s2, a2);
    }
    c2((n2 = n2.apply(t2, e2 || [])).next());
  });
}
function n(t2, e2) {
  var r2, n2, o2, i2 = { label: 0, sent: function() {
    if (1 & o2[0])
      throw o2[1];
    return o2[1];
  }, trys: [], ops: [] }, s2 = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return s2.next = a2(0), s2.throw = a2(1), s2.return = a2(2), typeof Symbol == "function" && (s2[Symbol.iterator] = function() {
    return this;
  }), s2;
  function a2(a3) {
    return function(c2) {
      return function(a4) {
        if (r2)
          throw new TypeError("Generator is already executing.");
        for (; s2 && (s2 = 0, a4[0] && (i2 = 0)), i2; )
          try {
            if (r2 = 1, n2 && (o2 = 2 & a4[0] ? n2.return : a4[0] ? n2.throw || ((o2 = n2.return) && o2.call(n2), 0) : n2.next) && !(o2 = o2.call(n2, a4[1])).done)
              return o2;
            switch (n2 = 0, o2 && (a4 = [2 & a4[0], o2.value]), a4[0]) {
              case 0:
              case 1:
                o2 = a4;
                break;
              case 4:
                return i2.label++, { value: a4[1], done: false };
              case 5:
                i2.label++, n2 = a4[1], a4 = [0];
                continue;
              case 7:
                a4 = i2.ops.pop(), i2.trys.pop();
                continue;
              default:
                if (!(o2 = i2.trys, (o2 = o2.length > 0 && o2[o2.length - 1]) || a4[0] !== 6 && a4[0] !== 2)) {
                  i2 = 0;
                  continue;
                }
                if (a4[0] === 3 && (!o2 || a4[1] > o2[0] && a4[1] < o2[3])) {
                  i2.label = a4[1];
                  break;
                }
                if (a4[0] === 6 && i2.label < o2[1]) {
                  i2.label = o2[1], o2 = a4;
                  break;
                }
                if (o2 && i2.label < o2[2]) {
                  i2.label = o2[2], i2.ops.push(a4);
                  break;
                }
                o2[2] && i2.ops.pop(), i2.trys.pop();
                continue;
            }
            a4 = e2.call(t2, i2);
          } catch (t3) {
            a4 = [6, t3], n2 = 0;
          } finally {
            r2 = o2 = 0;
          }
        if (5 & a4[0])
          throw a4[1];
        return { value: a4[0] ? a4[1] : void 0, done: true };
      }([a3, c2]);
    };
  }
}
typeof SuppressedError == "function" && SuppressedError;
var o = { exports: {} };
function i() {
}
i.prototype = { on: function(t2, e2, r2) {
  var n2 = this.e || (this.e = {});
  return (n2[t2] || (n2[t2] = [])).push({ fn: e2, ctx: r2 }), this;
}, once: function(t2, e2, r2) {
  var n2 = this;
  function o2() {
    n2.off(t2, o2), e2.apply(r2, arguments);
  }
  return o2._ = e2, this.on(t2, o2, r2);
}, emit: function(t2) {
  for (var e2 = [].slice.call(arguments, 1), r2 = ((this.e || (this.e = {}))[t2] || []).slice(), n2 = 0, o2 = r2.length; n2 < o2; n2++)
    r2[n2].fn.apply(r2[n2].ctx, e2);
  return this;
}, off: function(t2, e2) {
  var r2 = this.e || (this.e = {}), n2 = r2[t2], o2 = [];
  if (n2 && e2)
    for (var i2 = 0, s2 = n2.length; i2 < s2; i2++)
      n2[i2].fn !== e2 && n2[i2].fn._ !== e2 && o2.push(n2[i2]);
  return o2.length ? r2[t2] = o2 : delete r2[t2], this;
} }, o.exports = i;
var s = o.exports.TinyEmitter = i, a = function(t2) {
  var e2 = t2[1];
  return e2 != null;
}, c = function(t2) {
  var e2 = t2.properties, r2 = e2 === void 0 ? {} : e2, n2 = function(t3, e3) {
    var r3 = {};
    for (var n3 in t3)
      Object.prototype.hasOwnProperty.call(t3, n3) && e3.indexOf(n3) < 0 && (r3[n3] = t3[n3]);
    if (t3 != null && typeof Object.getOwnPropertySymbols == "function") {
      var o3 = 0;
      for (n3 = Object.getOwnPropertySymbols(t3); o3 < n3.length; o3++)
        e3.indexOf(n3[o3]) < 0 && Object.prototype.propertyIsEnumerable.call(t3, n3[o3]) && (r3[n3[o3]] = t3[n3[o3]]);
    }
    return r3;
  }(t2, ["properties"]), o2 = function(t3) {
    return Object.entries(t3).sort(function(t4, e3) {
      var r3 = t4[0], n3 = e3[0];
      return r3.localeCompare(n3, void 0);
    });
  };
  return JSON.stringify([o2(n2), o2(r2)]);
}, u = function(t2) {
  return r(void 0, void 0, void 0, function() {
    var e2;
    return n(this, function(o2) {
      switch (o2.label) {
        case 0:
          e2 = c(t2), o2.label = 1;
        case 1:
          return o2.trys.push([1, 3, , 4]), [4, (i2 = e2, r(void 0, void 0, void 0, function() {
            var t3, e3, r2, o3, s2;
            return n(this, function(n2) {
              switch (n2.label) {
                case 0:
                  if (t3 = typeof globalThis != "undefined" && ((o3 = globalThis.crypto) === null || o3 === void 0 ? void 0 : o3.subtle) ? (s2 = globalThis.crypto) === null || s2 === void 0 ? void 0 : s2.subtle : void 0, typeof TextEncoder == "undefined" || !(t3 == null ? void 0 : t3.digest) || typeof Uint8Array == "undefined")
                    throw new Error("Hashing function not available");
                  return e3 = new TextEncoder().encode(i2), [4, t3.digest("SHA-256", e3)];
                case 1:
                  return r2 = n2.sent(), [2, Array.from(new Uint8Array(r2)).map(function(t4) {
                    return t4.toString(16).padStart(2, "0");
                  }).join("")];
              }
            });
          }))];
        case 2:
          return [2, o2.sent()];
        case 3:
          return o2.sent(), [2, e2];
        case 4:
          return [2];
      }
      var i2;
    });
  });
}, l = "unleash-js@3.7.2", h = function() {
}, p = function() {
  function t2(t3) {
    var e2 = t3.onError, r2 = t3.onSent, n2 = t3.appName, o2 = t3.metricsInterval, i2 = t3.disableMetrics, s2 = i2 !== void 0 && i2, a2 = t3.url, c2 = t3.clientKey, u2 = t3.fetch, l2 = t3.headerName, p2 = t3.customHeaders, f2 = p2 === void 0 ? {} : p2, d2 = t3.metricsIntervalInitial, v2 = t3.connectionId;
    this.onError = e2, this.onSent = r2 || h, this.disabled = s2, this.metricsInterval = 1e3 * o2, this.metricsIntervalInitial = 1e3 * d2, this.appName = n2, this.url = a2 instanceof URL ? a2 : new URL(a2), this.clientKey = c2, this.bucket = this.createEmptyBucket(), this.fetch = u2, this.headerName = l2, this.customHeaders = f2, this.connectionId = v2;
  }
  return t2.prototype.start = function() {
    var t3 = this;
    if (this.disabled)
      return false;
    typeof this.metricsInterval == "number" && this.metricsInterval > 0 && (this.metricsIntervalInitial > 0 ? setTimeout(function() {
      t3.startTimer(), t3.sendMetrics();
    }, this.metricsIntervalInitial) : this.startTimer());
  }, t2.prototype.stop = function() {
    this.timer && (clearTimeout(this.timer), delete this.timer);
  }, t2.prototype.createEmptyBucket = function() {
    return { start: new Date(), stop: null, toggles: {} };
  }, t2.prototype.getHeaders = function() {
    var t3, e2 = ((t3 = {})[this.headerName] = this.clientKey, t3.Accept = "application/json", t3["Content-Type"] = "application/json", t3["x-unleash-sdk"] = l, t3["x-unleash-connection-id"] = this.connectionId, t3["x-unleash-appname"] = this.appName, t3);
    return Object.entries(this.customHeaders).filter(a).forEach(function(t4) {
      var r2 = t4[0], n2 = t4[1];
      return e2[r2] = n2;
    }), e2;
  }, t2.prototype.sendMetrics = function() {
    return r(this, void 0, void 0, function() {
      var t3, e2, r2;
      return n(this, function(n2) {
        switch (n2.label) {
          case 0:
            if (t3 = "".concat(this.url, "/client/metrics"), e2 = this.getPayload(), this.bucketIsEmpty(e2))
              return [2];
            n2.label = 1;
          case 1:
            return n2.trys.push([1, 3, , 4]), [4, this.fetch(t3, { cache: "no-cache", method: "POST", headers: this.getHeaders(), body: JSON.stringify(e2) })];
          case 2:
            return n2.sent(), this.onSent(e2), [3, 4];
          case 3:
            return r2 = n2.sent(), console.error("Unleash: unable to send feature metrics", r2), this.onError(r2), [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, t2.prototype.count = function(t3, e2) {
    return !(this.disabled || !this.bucket) && (this.assertBucket(t3), this.bucket.toggles[t3][e2 ? "yes" : "no"]++, true);
  }, t2.prototype.countVariant = function(t3, e2) {
    return !(this.disabled || !this.bucket) && (this.assertBucket(t3), this.bucket.toggles[t3].variants[e2] ? this.bucket.toggles[t3].variants[e2] += 1 : this.bucket.toggles[t3].variants[e2] = 1, true);
  }, t2.prototype.assertBucket = function(t3) {
    if (this.disabled || !this.bucket)
      return false;
    this.bucket.toggles[t3] || (this.bucket.toggles[t3] = { yes: 0, no: 0, variants: {} });
  }, t2.prototype.startTimer = function() {
    var t3 = this;
    this.timer = setInterval(function() {
      t3.sendMetrics();
    }, this.metricsInterval);
  }, t2.prototype.bucketIsEmpty = function(t3) {
    return Object.keys(t3.bucket.toggles).length === 0;
  }, t2.prototype.getPayload = function() {
    var t3 = e(e({}, this.bucket), { stop: new Date() });
    return this.bucket = this.createEmptyBucket(), { bucket: t3, appName: this.appName, instanceId: "browser" };
  }, t2;
}(), f = function() {
  function t2() {
    this.store = /* @__PURE__ */ new Map();
  }
  return t2.prototype.save = function(t3, e2) {
    return r(this, void 0, void 0, function() {
      return n(this, function(r2) {
        return this.store.set(t3, e2), [2];
      });
    });
  }, t2.prototype.get = function(t3) {
    return r(this, void 0, void 0, function() {
      return n(this, function(e2) {
        return [2, this.store.get(t3)];
      });
    });
  }, t2;
}(), d = function() {
  function t2(t3) {
    t3 === void 0 && (t3 = "unleash:repository"), this.prefix = t3;
  }
  return t2.prototype.save = function(t3, e2) {
    return r(this, void 0, void 0, function() {
      var r2, o2;
      return n(this, function(n2) {
        r2 = JSON.stringify(e2), o2 = "".concat(this.prefix, ":").concat(t3);
        try {
          window.localStorage.setItem(o2, r2);
        } catch (t4) {
          console.error(t4);
        }
        return [2];
      });
    });
  }, t2.prototype.get = function(t3) {
    try {
      var e2 = "".concat(this.prefix, ":").concat(t3), r2 = window.localStorage.getItem(e2);
      return r2 ? JSON.parse(r2) : void 0;
    } catch (t4) {
      console.error(t4);
    }
  }, t2;
}();
let v;
const m = new Uint8Array(16);
function g() {
  if (!v && (v = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !v))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return v(m);
}
const y = [];
for (let t2 = 0; t2 < 256; ++t2)
  y.push((t2 + 256).toString(16).slice(1));
var b = { randomUUID: typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto) };
function x(t2, e2, r2) {
  if (b.randomUUID && !e2 && !t2)
    return b.randomUUID();
  const n2 = (t2 = t2 || {}).random || (t2.rng || g)();
  if (n2[6] = 15 & n2[6] | 64, n2[8] = 63 & n2[8] | 128, e2) {
    r2 = r2 || 0;
    for (let t3 = 0; t3 < 16; ++t3)
      e2[r2 + t3] = n2[t3];
    return e2;
  }
  return function(t3, e3 = 0) {
    return y[t3[e3 + 0]] + y[t3[e3 + 1]] + y[t3[e3 + 2]] + y[t3[e3 + 3]] + "-" + y[t3[e3 + 4]] + y[t3[e3 + 5]] + "-" + y[t3[e3 + 6]] + y[t3[e3 + 7]] + "-" + y[t3[e3 + 8]] + y[t3[e3 + 9]] + "-" + y[t3[e3 + 10]] + y[t3[e3 + 11]] + y[t3[e3 + 12]] + y[t3[e3 + 13]] + y[t3[e3 + 14]] + y[t3[e3 + 15]];
  }(n2);
}
var T = function() {
  function t2() {
  }
  return t2.prototype.generateEventId = function() {
    return x();
  }, t2.prototype.createImpressionEvent = function(t3, r2, n2, o2, i2, s2) {
    var a2 = this.createBaseEvent(t3, r2, n2, o2, i2);
    return s2 ? e(e({}, a2), { variant: s2 }) : a2;
  }, t2.prototype.createBaseEvent = function(t3, e2, r2, n2, o2) {
    return { eventType: n2, eventId: this.generateEventId(), context: t3, enabled: e2, featureName: r2, impressionData: o2 };
  }, t2;
}(), w = ["userId", "sessionId", "remoteAddress", "currentTime"], E = function(t2) {
  return w.includes(t2);
}, S = { INIT: "initialized", ERROR: "error", READY: "ready", UPDATE: "update", IMPRESSION: "impression", SENT: "sent", RECOVERED: "recovered" }, I = "isEnabled", R = "getVariant", O = { name: "disabled", enabled: false, feature_enabled: false }, k = "repo", N = "repoLastUpdateTimestamp", A = function() {
  try {
    if (typeof window != "undefined" && "fetch" in window)
      return fetch.bind(window);
    if ("fetch" in globalThis)
      return fetch.bind(globalThis);
  } catch (t2) {
    console.error('Unleash failed to resolve "fetch"', t2);
  }
}, U = function(o2) {
  function i2(t2) {
    var r2 = t2.storageProvider, n2 = t2.url, i3 = t2.clientKey, s2 = t2.disableRefresh, a2 = s2 !== void 0 && s2, c2 = t2.refreshInterval, u2 = c2 === void 0 ? 30 : c2, l2 = t2.metricsInterval, h2 = l2 === void 0 ? 30 : l2, v2 = t2.metricsIntervalInitial, m2 = v2 === void 0 ? 2 : v2, g2 = t2.disableMetrics, y2 = g2 !== void 0 && g2, b2 = t2.appName, x2 = t2.environment, w2 = x2 === void 0 ? "default" : x2, E2 = t2.context, I2 = t2.fetch, R2 = I2 === void 0 ? A() : I2, O2 = t2.createAbortController, k2 = O2 === void 0 ? function() {
      try {
        if (typeof window != "undefined" && "AbortController" in window)
          return function() {
            return new window.AbortController();
          };
        if ("fetch" in globalThis)
          return function() {
            return new globalThis.AbortController();
          };
      } catch (t3) {
        console.error('Unleash failed to resolve "AbortController" factory', t3);
      }
    }() : O2, N2 = t2.bootstrap, U2 = t2.bootstrapOverride, D = U2 === void 0 || U2, j = t2.headerName, C = j === void 0 ? "Authorization" : j, P = t2.customHeaders, L = P === void 0 ? {} : P, H = t2.impressionDataAll, M = H !== void 0 && H, _ = t2.usePOSTrequests, F = _ !== void 0 && _, K = t2.experimental, V = o2.call(this) || this;
    if (V.toggles = [], V.etag = "", V.readyEventEmitted = false, V.fetchedFromServer = false, V.usePOSTrequests = false, V.started = false, !n2)
      throw new Error("url is required");
    if (!i3)
      throw new Error("clientKey is required");
    if (!b2)
      throw new Error("appName is required.");
    return V.eventsHandler = new T(), V.impressionDataAll = M, V.toggles = N2 && N2.length > 0 ? N2 : [], V.url = n2 instanceof URL ? n2 : new URL(n2), V.clientKey = i3, V.headerName = C, V.customHeaders = L, V.storage = r2 || (typeof window != "undefined" ? new d() : new f()), V.refreshInterval = a2 ? 0 : 1e3 * u2, V.context = e({ appName: b2, environment: w2 }, E2), V.usePOSTrequests = F, V.sdkState = "initializing", V.experimental = e({}, K), (K == null ? void 0 : K.togglesStorageTTL) && (K == null ? void 0 : K.togglesStorageTTL) > 0 && (V.experimental.togglesStorageTTL = 1e3 * K.togglesStorageTTL), V.lastRefreshTimestamp = 0, V.ready = new Promise(function(t3) {
      V.init().then(t3).catch(function(e2) {
        console.error(e2), V.sdkState = "error", V.emit(S.ERROR, e2), V.lastError = e2, t3();
      });
    }), R2 || console.error('Unleash: You must either provide your own "fetch" implementation or run in an environment where "fetch" is available.'), k2 || console.error('Unleash: You must either provide your own "AbortController" implementation or run in an environment where "AbortController" is available.'), V.fetch = R2, V.createAbortController = k2, V.bootstrap = N2 && N2.length > 0 ? N2 : void 0, V.bootstrapOverride = D, V.connectionId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t3) {
      var e2 = 16 * Math.random() | 0;
      return (t3 === "x" ? e2 : 3 & e2 | 8).toString(16);
    }), V.metrics = new p({ onError: V.emit.bind(V, S.ERROR), onSent: V.emit.bind(V, S.SENT), appName: b2, metricsInterval: h2, disableMetrics: y2, url: V.url, clientKey: i3, fetch: R2, headerName: C, customHeaders: L, metricsIntervalInitial: m2, connectionId: V.connectionId }), V;
  }
  return function(e2, r2) {
    if (typeof r2 != "function" && r2 !== null)
      throw new TypeError("Class extends value " + String(r2) + " is not a constructor or null");
    function n2() {
      this.constructor = e2;
    }
    t(e2, r2), e2.prototype = r2 === null ? Object.create(r2) : (n2.prototype = r2.prototype, new n2());
  }(i2, o2), i2.prototype.getAllToggles = function() {
    return function(t2, e2, r2) {
      if (r2 || arguments.length === 2)
        for (var n2, o3 = 0, i3 = e2.length; o3 < i3; o3++)
          !n2 && o3 in e2 || (n2 || (n2 = Array.prototype.slice.call(e2, 0, o3)), n2[o3] = e2[o3]);
      return t2.concat(n2 || Array.prototype.slice.call(e2));
    }([], this.toggles, true);
  }, i2.prototype.isEnabled = function(t2) {
    var e2, r2 = this.toggles.find(function(e3) {
      return e3.name === t2;
    }), n2 = !!r2 && r2.enabled;
    if (this.metrics.count(t2, n2), (r2 == null ? void 0 : r2.impressionData) || this.impressionDataAll) {
      var o3 = this.eventsHandler.createImpressionEvent(this.context, n2, t2, I, (e2 = r2 == null ? void 0 : r2.impressionData) !== null && e2 !== void 0 ? e2 : void 0);
      this.emit(S.IMPRESSION, o3);
    }
    return n2;
  }, i2.prototype.getVariant = function(t2) {
    var r2, n2 = this.toggles.find(function(e2) {
      return e2.name === t2;
    }), o3 = (n2 == null ? void 0 : n2.enabled) || false, i3 = n2 ? n2.variant : O;
    if (i3.name && this.metrics.countVariant(t2, i3.name), this.metrics.count(t2, o3), (n2 == null ? void 0 : n2.impressionData) || this.impressionDataAll) {
      var s2 = this.eventsHandler.createImpressionEvent(this.context, o3, t2, R, (r2 = n2 == null ? void 0 : n2.impressionData) !== null && r2 !== void 0 ? r2 : void 0, i3.name);
      this.emit(S.IMPRESSION, s2);
    }
    return e(e({}, i3), { feature_enabled: o3 });
  }, i2.prototype.updateToggles = function() {
    return r(this, void 0, void 0, function() {
      var t2 = this;
      return n(this, function(e2) {
        switch (e2.label) {
          case 0:
            return this.timerRef || this.fetchedFromServer ? [4, this.fetchToggles()] : [3, 2];
          case 1:
            return e2.sent(), [3, 4];
          case 2:
            return this.started ? [4, new Promise(function(e3) {
              var r2 = function() {
                t2.fetchToggles().then(function() {
                  t2.off(S.READY, r2), e3();
                });
              };
              t2.once(S.READY, r2);
            })] : [3, 4];
          case 3:
            e2.sent(), e2.label = 4;
          case 4:
            return [2];
        }
      });
    });
  }, i2.prototype.updateContext = function(t2) {
    return r(this, void 0, void 0, function() {
      var r2;
      return n(this, function(n2) {
        switch (n2.label) {
          case 0:
            return (t2.appName || t2.environment) && console.warn("appName and environment are static. They can't be updated with updateContext."), r2 = { environment: this.context.environment, appName: this.context.appName, sessionId: this.context.sessionId }, this.context = e(e({}, r2), t2), [4, this.updateToggles()];
          case 1:
            return n2.sent(), [2];
        }
      });
    });
  }, i2.prototype.getContext = function() {
    return e({}, this.context);
  }, i2.prototype.setContextField = function(t2, r2) {
    var n2, o3;
    if (E(t2))
      this.context = e(e({}, this.context), ((n2 = {})[t2] = r2, n2));
    else {
      var i3 = e(e({}, this.context.properties), ((o3 = {})[t2] = r2, o3));
      this.context = e(e({}, this.context), { properties: i3 });
    }
    this.updateToggles();
  }, i2.prototype.removeContextField = function(t2) {
    var r2;
    E(t2) ? this.context = e(e({}, this.context), ((r2 = {})[t2] = void 0, r2)) : typeof this.context.properties == "object" && delete this.context.properties[t2], this.updateToggles();
  }, i2.prototype.setReady = function() {
    this.readyEventEmitted = true, this.emit(S.READY);
  }, i2.prototype.init = function() {
    return r(this, void 0, void 0, function() {
      var t2, r2, o3;
      return n(this, function(n2) {
        switch (n2.label) {
          case 0:
            return [4, this.resolveSessionId()];
          case 1:
            return t2 = n2.sent(), this.context = e({ sessionId: t2 }, this.context), r2 = this, [4, this.storage.get(k)];
          case 2:
            return r2.toggles = n2.sent() || [], o3 = this, [4, this.getLastRefreshTimestamp()];
          case 3:
            return o3.lastRefreshTimestamp = n2.sent(), !this.bootstrap || !this.bootstrapOverride && this.toggles.length !== 0 ? [3, 6] : [4, this.storage.save(k, this.bootstrap)];
          case 4:
            return n2.sent(), this.toggles = this.bootstrap, this.sdkState = "healthy", [4, this.storeLastRefreshTimestamp()];
          case 5:
            n2.sent(), this.setReady(), n2.label = 6;
          case 6:
            return this.sdkState = "healthy", this.emit(S.INIT), [2];
        }
      });
    });
  }, i2.prototype.start = function() {
    return r(this, void 0, void 0, function() {
      var t2, e2 = this;
      return n(this, function(r2) {
        switch (r2.label) {
          case 0:
            return this.started = true, this.timerRef ? (console.error("Unleash SDK has already started, if you want to restart the SDK you should call client.stop() before starting again."), [2]) : [4, this.ready];
          case 1:
            return r2.sent(), this.metrics.start(), t2 = this.refreshInterval, [4, this.initialFetchToggles()];
          case 2:
            return r2.sent(), t2 > 0 && (this.timerRef = setInterval(function() {
              return e2.fetchToggles();
            }, t2)), [2];
        }
      });
    });
  }, i2.prototype.stop = function() {
    this.timerRef && (clearInterval(this.timerRef), this.timerRef = void 0), this.metrics.stop();
  }, i2.prototype.isReady = function() {
    return this.readyEventEmitted;
  }, i2.prototype.getError = function() {
    return this.sdkState === "error" ? this.lastError : void 0;
  }, i2.prototype.sendMetrics = function() {
    return this.metrics.sendMetrics();
  }, i2.prototype.resolveSessionId = function() {
    return r(this, void 0, void 0, function() {
      var t2;
      return n(this, function(e2) {
        switch (e2.label) {
          case 0:
            return this.context.sessionId ? [2, this.context.sessionId] : [4, this.storage.get("sessionId")];
          case 1:
            return (t2 = e2.sent()) ? [3, 3] : (t2 = Math.floor(1e9 * Math.random()), [4, this.storage.save("sessionId", t2.toString(10))]);
          case 2:
            e2.sent(), e2.label = 3;
          case 3:
            return [2, t2.toString(10)];
        }
      });
    });
  }, i2.prototype.getHeaders = function() {
    var t2, e2 = this.usePOSTrequests, r2 = ((t2 = {})[this.headerName] = this.clientKey, t2.Accept = "application/json", t2["x-unleash-sdk"] = l, t2["x-unleash-connection-id"] = this.connectionId, t2["x-unleash-appname"] = this.context.appName, t2);
    return e2 && (r2["Content-Type"] = "application/json"), this.etag && (r2["If-None-Match"] = this.etag), Object.entries(this.customHeaders).filter(a).forEach(function(t3) {
      var e3 = t3[0], n2 = t3[1];
      return r2[e3] = n2;
    }), r2;
  }, i2.prototype.storeToggles = function(t2) {
    return r(this, void 0, void 0, function() {
      return n(this, function(e2) {
        switch (e2.label) {
          case 0:
            return this.toggles = t2, this.emit(S.UPDATE), [4, this.storage.save(k, t2)];
          case 1:
            return e2.sent(), [2];
        }
      });
    });
  }, i2.prototype.isTogglesStorageTTLEnabled = function() {
    var t2;
    return !!(((t2 = this.experimental) === null || t2 === void 0 ? void 0 : t2.togglesStorageTTL) && this.experimental.togglesStorageTTL > 0);
  }, i2.prototype.isUpToDate = function() {
    var t2;
    if (!this.isTogglesStorageTTLEnabled())
      return false;
    var e2 = Date.now(), r2 = ((t2 = this.experimental) === null || t2 === void 0 ? void 0 : t2.togglesStorageTTL) || 0;
    return this.lastRefreshTimestamp > 0 && this.lastRefreshTimestamp <= e2 && e2 - this.lastRefreshTimestamp <= r2;
  }, i2.prototype.getLastRefreshTimestamp = function() {
    return r(this, void 0, void 0, function() {
      var t2, e2;
      return n(this, function(r2) {
        switch (r2.label) {
          case 0:
            return this.isTogglesStorageTTLEnabled() ? [4, this.storage.get(N)] : [3, 3];
          case 1:
            return t2 = r2.sent(), [4, u(this.context)];
          case 2:
            return e2 = r2.sent(), [2, (t2 == null ? void 0 : t2.key) === e2 ? t2.timestamp : 0];
          case 3:
            return [2, 0];
        }
      });
    });
  }, i2.prototype.storeLastRefreshTimestamp = function() {
    return r(this, void 0, void 0, function() {
      var t2, e2;
      return n(this, function(r2) {
        switch (r2.label) {
          case 0:
            return this.isTogglesStorageTTLEnabled() ? (this.lastRefreshTimestamp = Date.now(), e2 = {}, [4, u(this.context)]) : [3, 3];
          case 1:
            return e2.key = r2.sent(), e2.timestamp = this.lastRefreshTimestamp, t2 = e2, [4, this.storage.save(N, t2)];
          case 2:
            r2.sent(), r2.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, i2.prototype.initialFetchToggles = function() {
    if (!this.isUpToDate())
      return this.fetchToggles();
    this.fetchedFromServer || (this.fetchedFromServer = true, this.setReady());
  }, i2.prototype.fetchToggles = function() {
    return r(this, void 0, void 0, function() {
      var t2, e2, r2, o3, i3, s2, c2, u2, l2;
      return n(this, function(n2) {
        switch (n2.label) {
          case 0:
            if (!this.fetch)
              return [3, 9];
            this.abortController && this.abortController.abort(), this.abortController = (l2 = this.createAbortController) === null || l2 === void 0 ? void 0 : l2.call(this), t2 = this.abortController ? this.abortController.signal : void 0, n2.label = 1;
          case 1:
            return n2.trys.push([1, 7, 8, 9]), e2 = this.usePOSTrequests, r2 = e2 ? this.url : function(t3, e3) {
              var r3 = new URL(t3.toString());
              return Object.entries(e3).filter(a).forEach(function(t4) {
                var e4 = t4[0], n3 = t4[1];
                e4 === "properties" && n3 ? Object.entries(n3).filter(a).forEach(function(t5) {
                  var e5 = t5[0], n4 = t5[1];
                  return r3.searchParams.append("properties[".concat(e5, "]"), n4);
                }) : r3.searchParams.append(e4, n3);
              }), r3;
            }(this.url, this.context), o3 = e2 ? "POST" : "GET", i3 = e2 ? JSON.stringify({ context: this.context }) : void 0, [4, this.fetch(r2.toString(), { method: o3, cache: "no-cache", headers: this.getHeaders(), body: i3, signal: t2 })];
          case 2:
            return s2 = n2.sent(), this.sdkState === "error" && s2.status < 400 && (this.sdkState = "healthy", this.emit(S.RECOVERED)), s2.ok ? (this.etag = s2.headers.get("ETag") || "", [4, s2.json()]) : [3, 5];
          case 3:
            return c2 = n2.sent(), [4, this.storeToggles(c2.toggles)];
          case 4:
            return n2.sent(), this.sdkState !== "healthy" && (this.sdkState = "healthy"), this.fetchedFromServer || (this.fetchedFromServer = true, this.setReady()), this.storeLastRefreshTimestamp(), [3, 6];
          case 5:
            s2.status === 304 ? this.storeLastRefreshTimestamp() : (console.error("Unleash: Fetching feature toggles did not have an ok response"), this.sdkState = "error", this.emit(S.ERROR, { type: "HttpError", code: s2.status }), this.lastError = { type: "HttpError", code: s2.status }), n2.label = 6;
          case 6:
            return [3, 9];
          case 7:
            return typeof (u2 = n2.sent()) == "object" && u2 !== null && "name" in u2 && u2.name === "AbortError" || (console.error("Unleash: unable to fetch feature toggles", u2), this.sdkState = "error", this.emit(S.ERROR, u2), this.lastError = u2), [3, 9];
          case 8:
            return this.abortController = null, [7];
          case 9:
            return [2];
        }
      });
    });
  }, i2;
}(s);
const ContextStateSymbol = Symbol("Context state identifier");
const ContextUpdateSymbol = Symbol("Context update identifier");
function useUnleashProvide({
  config,
  unleashClient,
  startClient = true
}) {
  var _a, _b;
  const client = ref(unleashClient);
  const flagsReady = ref(false);
  const flagsError = ref(null);
  if (!config && !unleashClient) {
    console.warn(`You must provide either a config or an unleash client to the flag provider. If you are initializing the client in useEffect, you can avoid this warning by
    checking if the client exists before rendering.`);
  }
  if (!client.value && config) {
    client.value = new U(config);
  }
  (_a = client.value) == null ? void 0 : _a.on("ready", () => {
    flagsReady.value = true;
  });
  (_b = client.value) == null ? void 0 : _b.on("error", (e2) => {
    flagsError.value = e2;
  });
  const updateContext = async (context2) => {
    var _a2;
    await ((_a2 = client.value) == null ? void 0 : _a2.updateContext(context2));
  };
  const isEnabled = (name) => {
    var _a2;
    return (_a2 = client.value) == null ? void 0 : _a2.isEnabled(name);
  };
  const getVariant = (name) => {
    var _a2;
    return (_a2 = client.value) == null ? void 0 : _a2.getVariant(name);
  };
  const on = (event, ...args) => {
    var _a2;
    return (_a2 = client.value) == null ? void 0 : _a2.on(event, ...args);
  };
  const context = reactive({
    on,
    updateContext,
    isEnabled,
    getVariant,
    client,
    flagsReady,
    flagsError
  });
  const update = (property, value) => {
    context[property] = value;
  };
  const start = () => {
    var _a2;
    if (startClient || !unleashClient) {
      (_a2 = client == null ? void 0 : client.value) == null ? void 0 : _a2.start();
    }
  };
  return {
    context: toRefs(context),
    update,
    start
  };
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FlagProvider",
  props: {
    config: null,
    unleashClient: null,
    startClient: { type: Boolean }
  },
  setup(__props) {
    const {
      config,
      unleashClient,
      startClient = true
    } = __props;
    const { context, start, update } = useUnleashProvide({
      config,
      unleashClient,
      startClient
    });
    provide(ContextStateSymbol, context);
    provide(ContextUpdateSymbol, update);
    onMounted(() => {
      start();
    });
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default");
    };
  }
});
const useFlag = (name) => {
  const { isEnabled, client } = inject(ContextStateSymbol, {});
  const flag = ref(Boolean(isEnabled == null ? void 0 : isEnabled.value(name)));
  function onUpdate() {
    const enabled = isEnabled == null ? void 0 : isEnabled.value(name);
    if (enabled !== flag.value) {
      flag.value = !!enabled;
    }
  }
  function onReady() {
    flag.value = Boolean(isEnabled == null ? void 0 : isEnabled.value(name));
  }
  client == null ? void 0 : client.value.on("ready", onReady);
  client == null ? void 0 : client.value.on("update", onUpdate);
  onUnmounted(() => {
    client == null ? void 0 : client.value.off("ready", onReady);
    client == null ? void 0 : client.value.off("update", onUpdate);
  });
  return flag;
};
const useFlagsStatus = () => {
  const { flagsReady, flagsError } = inject(ContextStateSymbol, {});
  return { flagsReady, flagsError };
};
const variantHasChanged = (oldVariant, newVariant) => {
  var _a, _b, _c, _d;
  const variantsAreEqual = (oldVariant == null ? void 0 : oldVariant.name) === (newVariant == null ? void 0 : newVariant.name) && (oldVariant == null ? void 0 : oldVariant.enabled) === (newVariant == null ? void 0 : newVariant.enabled) && (oldVariant == null ? void 0 : oldVariant.feature_enabled) === (newVariant == null ? void 0 : newVariant.feature_enabled) && ((_a = oldVariant == null ? void 0 : oldVariant.payload) == null ? void 0 : _a.type) === ((_b = newVariant == null ? void 0 : newVariant.payload) == null ? void 0 : _b.type) && ((_c = oldVariant == null ? void 0 : oldVariant.payload) == null ? void 0 : _c.value) === ((_d = newVariant == null ? void 0 : newVariant.payload) == null ? void 0 : _d.value);
  return !variantsAreEqual;
};
const useVariant = (name) => {
  const { getVariant, client } = inject(ContextStateSymbol, {});
  const variant = ref(getVariant == null ? void 0 : getVariant.value(name));
  function onUpdate() {
    const newVariant = getVariant == null ? void 0 : getVariant.value(name);
    if (variantHasChanged(variant == null ? void 0 : variant.value, newVariant)) {
      variant.value = newVariant;
    }
  }
  function onReady() {
    variant.value = getVariant == null ? void 0 : getVariant.value(name);
  }
  client == null ? void 0 : client.value.on("ready", onReady);
  client == null ? void 0 : client.value.on("update", onUpdate);
  onUnmounted(() => {
    client == null ? void 0 : client.value.off("ready", onReady);
    client == null ? void 0 : client.value.off("update", onUpdate);
  });
  return variant || {};
};
const useUnleashContext = () => {
  const { updateContext } = inject(ContextStateSymbol, {});
  return updateContext == null ? void 0 : updateContext.value;
};
const useUnleashClient = () => {
  const { client } = inject(ContextStateSymbol, {});
  return client == null ? void 0 : client.value;
};
const plugin = {
  install(app, { config, unleashClient, startClient }) {
    const { context, update, start } = useUnleashProvide({
      config,
      unleashClient,
      startClient
    });
    app.provide(ContextStateSymbol, context);
    app.provide(ContextUpdateSymbol, update);
    start();
  }
};
export { ContextStateSymbol, ContextUpdateSymbol, _sfc_main as FlagProvider, f as InMemoryStorageProvider, d as LocalStorageProvider, U as UnleashClient, _sfc_main as default, plugin, useFlag, useFlagsStatus, useUnleashClient, useUnleashContext, useVariant };
